// extracted by mini-css-extract-plugin
module.exports = {"layout":"page_100mm_40mm_4_Labels_37mm_22_3mm_layout__2Yjry"};